export const Types = {
  GET_REQUEST: 'productsTypes/GET_REQUEST',
  GET_SUCCESS: 'productsTypes/GET_SUCCESS',
  GET_FAILURE: 'productsTypes/GET_FAILURE',

  GET_LIST_REQUEST: 'productsTypes/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'productsTypes/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'productsTypes/GET_LIST_FAILURE',

  UPDATE_REQUEST: 'productsTypes/UPDATE_REQUEST',
  UPDATE_SUCCESS: 'productsTypes/UPDATE_SUCCESS',
  UPDATE_FAILURE: 'productsTypes/UPDATE_FAILURE',
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,

  detail: {
    data: {},
    loading: true,
  },

  update: {
    loading: false,
  },
};

export default function productsTypes(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.productType.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.productsTypes.data,
        page: action.payload.productsTypes.meta.current_page,
        totals: action.payload.productsTypes.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getProductTypeRequest: id => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getProductTypeSuccess: productType => ({
    type: Types.GET_SUCCESS,
    payload: { productType },
  }),

  getProductTypeFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getProductsTypesRequest: (page = 1) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page },
  }),

  getProductsTypesSuccess: productsTypes => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { productsTypes },
  }),

  getProductsTypesFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  updateProductsTypeRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateProductsTypeSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updateProductsTypeFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),
};
